import { render, staticRenderFns } from "./ReportPrices.vue?vue&type=template&id=332a1c63"
import script from "./ReportPrices.vue?vue&type=script&lang=js"
export * from "./ReportPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports